import { useEffect, useState } from 'react';

const HUBSPOT_SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/14519097.js';

export function useHubSpotScript(consentGiven: boolean) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!consentGiven) return;
    // Verifica se o script já está presente
    const existingScript = document.querySelector(`script[src="${HUBSPOT_SCRIPT_SRC}"]`);
    if (existingScript) {
      if ((existingScript as any)._hsLoaded) {
        setLoaded(true);
      } else {
        existingScript.addEventListener('load', () => setLoaded(true));
      }
      return;
    }
    // Cria o script se não existir
    const script = document.createElement('script');
    script.src = HUBSPOT_SCRIPT_SRC;
    script.defer = true;
    script.onload = () => {
      (script as any)._hsLoaded = true;
      setLoaded(true);
    };
    document.body.appendChild(script);
    return () => {
      script.removeEventListener('load', () => setLoaded(true));
    };
  }, [consentGiven]);

  return loaded;
}
